import React from 'react'

/**
 * EmailCardBuy component renders a card with an email input field and buttons to send and close the card.
 * 
 * @component
 * @param {Object} props - The properties object.
 * @param {string} props.email - The email address to be sent.
 * @param {Function} props.setEmail - The callback function to update the email address.
 * @param {Function} props.onSubmit - The callback function to call when the send button is clicked.
 * @param {Function} props.onClose - The callback function to call when the close button is clicked.
 */
const EmailCardBuy = ({
    /**
     * The email address to be sent.
     */
    email,
    /**
     * The callback function to update the email address.
     */
    setEmail,
    /**
     * The callback function to call when the send button is clicked.
     */
    onSubmit,
    /**
     * The callback function to call when the close button is clicked.
     */
    onClose
  }) => {
    return (
      <div
        style={{
          /**
           * Custom styles for the card container
           */
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '400px',
          padding: '20px',
          borderRadius: '8px',
          backgroundColor: '#fff',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          zIndex: 1000 // Ensure the card appears above other content
        }}
      >
        {/* Input field for email */}
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            /**
             * Custom styles for the input field
             */
            width: '99%',
            padding: '10px',
            marginBottom: '20px',
            borderRadius: '5px',
            border: '1px solid #ccc',
            fontSize: '16px'
          }}
        />
  
        {/* Button to send email */}
        <button
          onClick={onSubmit}
          style={{
            /**
             * Custom styles for the send button
             */
            width: '100%',
            padding: '10px',
            backgroundColor: '#1976d2',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            marginBottom: '10px',
            textTransform: 'none'
          }}
        >
          Send Email
        </button>
  
        {/* Button to close the card */}
        <button
          onClick={onClose}
          style={{
            /**
             * Custom styles for the close button
             */
            width: '100%',
            padding: '10px',
            backgroundColor: '#fff',
            color: '#1976d2',
            border: '1px solid #1976d2',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            textTransform: 'none'
          }}
        >
          Close
        </button>
      </div>
    );
  };
  
  /**
   * Exports the EmailCardBuy component as the default export.
   */
  export default EmailCardBuy;